import { alpha, Modal, styled } from '@mui/material';

export const MainDivStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  padding: 24,
}));

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '90vw',
  height: '25vh',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
});

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  padding: 24,
  '@media(max-width: 750px)': {
    padding: 0,
  },
}));

export const ContainerFolderNameStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 5,
  '& h3': {
    marginBottom: 32,
  },
  '& .enable': {
    backgroundColor: alpha(theme.palette.global.lightgray, 0.1),
    padding: 3,
    borderRadius: 5,
    cursor: 'pointer',
  },
  '& .folderName': {
    color: theme.palette.global.lightgray,
  },
}));

export const SelectionDefaultStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: '24px 24px 24px 10px',
  justifyContent: 'space-between',
  '& .typography': {
    cursor: 'pointer',
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
    '&:hover': {
      color: alpha(theme.palette.secondary.main, 0.7),
    },
  },
  '@media(max-width: 750px)': {
    margin: 0,
  },
}));

export const PreviewStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  backgroundColor: theme.palette.global.white,
  '& .image': {
    margin: 10,
    width: 135,
    height: 135,
    overflow: 'hidden',
    '&:hover': {
      cursor: 'zoom-in',
      transform: 'scale(1.2)',
    },
    '& input[type=checkbox]': {
      position: 'relative',
      top: 70,
      left: 75,
    },
  },
  '@media(min-width: 750px)': {
    marginTop: -32,
  },
}));

export const DivNoDataStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
  marginLeft: '5%',
});

export const DefaultPageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 100,
  '& p': {
    color: theme.palette.global.lightgray,
    marginBottom: 50,
  },
}));

export const ModalStyled = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  '& .close': {
    position: 'absolute',
    right: '5.5rem',
    top: '1.5rem',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    color: theme.palette.primary.main,
    fontSize: 38,
    '@media(max-width: 750px)': {
      right: 16,
      top: 80,
      fontSize: 28,
    },
  },
}));
